import React, { useCallback, useEffect, useMemo, useState } from 'react';
import type { NextPage } from 'next';

import styles from './index.module.scss';
import cName from "classnames";

import Wrapper from '@/components/wrapper';
import Pagination from '@/components/seo-pagination';

import request from '@/utils/request';
import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';

import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface IProps {

}
export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data } = await request.get(`/api/get_download_list`, {
    params: {
      lang: context.locale || context.defaultLocale || 'cn',
      page: context.query.page || 1,
      rows: 8,
    }
  })
  return {
    props: {
      ...res.props,
      data: data?.data || null,
    }
  }
}

const Download: NextPage<IProps> = ({ menuDetail, data }: any) => {
  const router = useRouter();
  const t = useTranslations("exhibition.download");
  return (
    <div>
      <Wrapper>
        <div className={cName(styles.container)}>
          {getHead(menuDetail)}
          <div className={cName(styles.inner, 'm-1600')}>
            <h2>{t('title')}</h2>
            <ul className={styles.list}>
              {
                data?.list?.map((item: any) => (
                  <li key={item?.id}>
                    <a className={styles.item} href={item?.link || item?.file} target='_blank'>
                      <img src={item?.image} alt={item?.title} />
                      <p>{item?.title}</p>
                    </a>
                  </li>
                ))
              }
            </ul>
            <Pagination
              page={Number(router.query.page || 1)}
              total={data?.total}
              size={data?.list_rows}
            />
          </div>
        </div>
      </Wrapper >
    </div >
  );
};

export default Download;
